export const UPDATE_MEASUREMENT_UNIT = 'UPDATE_MEASUREMENT_UNIT';
export const updateMeasurementUnit = measurementUnit => {
    return {
        type: UPDATE_MEASUREMENT_UNIT,
        payload: measurementUnit,
    };
};
